/* eslint-disable no-unused-vars */
/**
 * @description:  Language
 */
export enum LocalStorageEnum {
   Session = 'session',
   SavedAnswers = 'saved-answers'
}
